import { Injectable, EventEmitter, Output, OnDestroy } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { tap } from 'rxjs/operators';
import { ILicense } from 'src/app/shared/models/license/license.model';
import { AuthResponseData } from 'src/app/shared/models/authentication/auth-response-data';

@Injectable({
    providedIn: 'root'
})
export class LicenseService implements OnDestroy
{

    private subscriptions : Subscription[]= [];

    // can be subscribed for changes.


    licenseChangeSubject = new Subject<ILicense>();

    private _license: ILicense

    // better to subscribe on the service instead of using the field
    get license(): ILicense
    {
        return this._license;
    }

    set license(license: ILicense)
    {
        this._license = license;
    }

    // someone from outsite can change.
    private changeLicense(): void
    {
        this.licenseChangeSubject.next(this._license);
    }

    constructor( private http: HttpClient ) { }

    public checkIsValidDate(): boolean
    {
        let checkDefinedValue = this._license.expiryDate.substring(0, 10);
        if (checkDefinedValue == '0001-01-01')
        {
            return false
        }
        else return true;
    }

    // must be made sure that always a license object will be returned
    // also after a refresh
    public getLicense(): Observable<ILicense>
    {
        if (this._license !== undefined)
        {
            return of(this._license)
        }

        return this.http.get<ILicense>(AppConfigService.appConfig.WebAPIServer + "/api/license/get").pipe(
            tap(data => this._license = data),
        );
    }


    // basically this should be ok if license is not saved in the session
    public updateLicense(): void
    {
        this.subscriptions.push(this.http.get<ILicense>(AppConfigService.appConfig.WebAPIServer + "/api/license/get").subscribe(
            data =>
            {
                this._license = data;
                this.changeLicense();
            }));
    }

    public setLicense(license : ILicense) : void
    {
        this._license = license;
        this.changeLicense();
    }

    ngOnDestroy()
    {
        this.subscriptions.forEach(s => s.unsubscribe() );
    }
}
